// Full screen, outside the sidebar; the page applies the audience gate itself
export default {
  path: '/v5/onboarding',
  name: 'V5_onboarding',
  component: () => import('./OnboardingPage.vue'),
  meta: { bare: true },
};
